/**
 * Copyright 2025 Nordcloud Oy or its affiliates. All Rights Reserved.
 */

import styled from "styled-components";
import { theme } from "@nordcloud/gnui";

type Props = {
  hasPadding?: boolean;
};

export const ResourceDetailsResourceGroupsGridColumns = styled.div<Props>`
  display: grid;
  grid-template-columns: 3rem minmax(11rem, 1fr) 13rem 13rem 24rem 7rem 5rem;
  padding: ${(props) => (props.hasPadding ? theme.spacing.spacing03 : "0")};
`;
